import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import moment from 'moment';
import { IPSService } from '@/services/ipsServices';
import { appEnvConfig } from '@/configs/appConfigs';
import IPSDialog from '@/views/components/picker/dialog';
import DialogFactory from '@/views/components/picker/dialogFactory';
import linkDialogStyle from '@/views/components/linkForm/style.vue';
import { Functions } from '@/library/utils/functions';
import importBatchSet from '@/views/components/importBatchSet';
import { noop } from '@/util';

interface SpecialProConfigList {
  ggsppId?: number;
  policyId?: number;
  goodsCode?: string;
  goodsName?: string;
  originPrice?: string | number;
  commission?: number;
  updatePerson?: string;
  updateTime?: number | string;
}

@DialogFactory
@Component({
  mixins: [linkDialogStyle],
  components: {},
})
export default class SpecialProConfig extends IPSDialog {
  keyword = '';

  page = 1;

  pageSize = 10;

  totalCount = 0;

  policyId = 0;

  sgId = 0;

  data: SpecialProConfigList[] = [];

  disabled = false;

  confirmloading = false;

  footer = false;

  selectedPro = [];

  empCode = '';

  cancelText = '关闭';

  mounted() {
    this.getData();
  }

  getData() {
    IPSService.proCommPolicyList({
      postParams: {
        policyId: this.policyId,
        page: this.page,
        pageSize: this.pageSize,
        keyword: this.keyword,
        sgId: this.sgId,
      },
    }).then((response) => {
      this.data = response.list.map((v) => {
        v.updateTime = moment(v.updateTime * 1000).format('YYYY-MM-DD HH:mm:ss');
        v.commission = v.commission / 100;
        return v;
      });
      this.totalCount = response.count;
    });
  }

  handleSearch() {
    this.getData();
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getData();
  }

  onPageChange(val) {
    this.page = val;
    this.getData();
  }

  onDel(ggsppIds) {
    this.$confirm('确定删除?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((res) => {
      if (res === 'confirm') {
        IPSService.productCommissionDelete({
          postParams: {
            ggsppIds,
          },
        }).then((result) => {
          this.$message.success('删除成功');
          this.getData();
        });
      }
    }, noop);
  }

  onSaveConfig(ggsppId, commission) {
    if (typeof commission === 'number' && commission >= 0 && commission <= 100) {
      IPSService.productCommissionSave({
        postParams: {
          ggsppId,
          commission: commission * 100,
        },
      }).then(
        (result) => {
          this.$message.success('修改成功');
        },
        () => {
          this.$message.error('修改失败');
        },
      );
    }
  }

  batchSet() {
    importBatchSet
      .open({
        title: '批量设置',
        postParams: {
          sgId: this.sgId,
          keyword: this.keyword,
          policyId: this.policyId,
        },
        fromKey: 'proCommission',
        empCode: this.empCode,
        excelHeader: [
          { header: '货号', key: 'proCode', width: 30 },
          { header: '佣金比例(%)', key: 'commission', width: 20 },
          { header: '备注：如需设置成“20%”，请输入“20”，请勿在数字后加上“%”', key: 'ob', width: 80 },
        ],
        name: '批量设置',
        importUrl: `${Functions.ipsHostUrlApi()}/admin/product/commission/template/import`,
        importParams: { sgId: this.sgId, policyId: this.policyId },
      })
      .then(() => {
        this.getData();
      }, noop);
  }

  // 删除全部
  clearAll() {
    this.$confirm('确认删除所有商品数据？删除后数据不可恢复！', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.productCommissionAllDelete({
          postParams: {
            policyId: this.policyId,
          },
        }).then((response) => {
          this.$message.success('删除成功');
          this.getData();
        });
      }
    });
  }

  renderBottomButton(h) {
    return (
      <div class="pro-config-fotter">
        <div>
          {!this.disabled && [
            <el-button type="primary" onClick={this.batchSet.bind(this)}>
              批量设置
            </el-button>,
            <span class={['scopeSpan', !this.selectedPro.length && 'disabled']} onClick={() => this.selectedPro.length && this.onDel(this.selectedPro.map(v => v.ggsppId))}>
              批量删除
            </span>,
            <span class="scopeSpan" onClick={this.clearAll.bind(this)}>
              全部删除
            </span>,
          ]}
        </div>
        <div>
          <el-button onClick={this.onCancel.bind(this)}>{this.cancelText}</el-button>
          {/* {!this.disabled && (
            <el-button type="primary" onClick={this.onConfirm} loading={this.confirmloading} disabled={this.readonly}>
              {this.confirmText}
            </el-button>
          )} */}
        </div>
      </div>
    );
  }

  renderContent(h) {
    return (
      <div class="select-list pro-config-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="货号"></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
        </div>
        <el-table
          data={this.data}
          height="350px"
          style="width: 100%"
          on-selection-change={(v) => {
            this.selectedPro = v;
          }}
          tooltip-effect="light">
          <el-table-column type="selection" width="55px" align="center" fixed />
          <el-table-column type="index" label="ID" width="40" />
          <el-table-column prop="goodsCode" label="商品货号" show-overflow-tooltip min-width={2} />
          <el-table-column prop="goodsName" label="商品名称" show-overflow-tooltip min-width={2} />
          <el-table-column prop="originPrice" label="商品牌价" show-overflow-tooltip min-width={2} />
          <el-table-column
            prop="commission"
            label="佣金比例"
            min-width={2}
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <div>
                      <el-input-number
                        controls={false}
                        precision={2}
                        v-model={scope.row.commission}
                        // 杭俊雅说可以为0
                        class={['pro-commission', (typeof scope.row.commission != 'number' || scope.row.commission < 0 || scope.row.commission > 100) && 'pro-commission-error']}
                        onBlur={() => this.onSaveConfig(scope.row.ggsppId, scope.row.commission)}
                      />{' '}
                      %
                    </div>
                  );
                },
              },
            }}
          />
          <el-table-column prop="updatePerson" label="更新人" show-overflow-tooltip min-width={1} />
          <el-table-column prop="updateTime" label="更新时间" show-overflow-tooltip min-width={3} />
          <el-table-column
            label="操作"
            align="center"
            min-width={2}
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onDel.bind(this, [scope.row.ggsppId])}>
                      删除
                    </span>
                  );
                },
              },
            }}
          />
        </el-table>
        <div class="bottomWrapper border-top-none">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.totalCount}
          />
        </div>
        {this.renderBottomButton(h)}
      </div>
    );
  }
}
